import { brandProviderFactory, useBrand } from '@cof/plastic-components';

import partners, { getPartner } from './partners';

const BrandProvider = brandProviderFactory({
    brandProviderStrategy: getPartner,
    defaultBrand: partners.DEFAULT,
    brandAllowList: [
        partners.DEFAULT,
        partners.LUMA,
        partners.VERY,
        partners.LITTLEWOODS,
        partners.OCEAN,
        partners.THINKMONEY,
        partners.POSTOFFICE,
        partners.ASOS
    ]
});
// @ts-expect-error TS2339: Property 'displayName' does not exist on type '( children :  children: ReactNode; ) => Element'.
BrandProvider.displayName = 'BrandProvider';

export { BrandProvider, useBrand };
